import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { shopsActions } from '../../actions';
import {
  defaultShopsSelector, searchQuerySelector,
  viewAllShopsSelector, statesSelector, selectedStateSelector,
  directionModeSelector, directionToSelector,
  selectedTravelModeSelector,
} from '../../selectors/shops';
import mapServices from '../../services/mapService';
import styles from './Search.module.sass';
import Input from '../../../ui_kit/input/Input';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';
import Select from '../../../ui_kit/select/Select';
import DEFAULT_SELECTORS from '../../constants/selector';
import CloseIcon from '../../../../images/icons/close.svg';
import searchIcon from '../../../../images/icons/search.svg';

const SEARCH_DELAY = 500;
const DIRECTIONS_DELAY = 1000;
class Search extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchDelayTimeout: null,
    };
  }

  onChangeInput = (event) => {
    const { searchDelayTimeout } = this.state;
    const { setSearchQuery } = this.props;

    const currentSearchQuery = event.target.value;

    clearTimeout(searchDelayTimeout);

    const timeout = setTimeout(() => {
      if (currentSearchQuery === '') {
        this.clearQuery();
        return;
      }

      this.search(currentSearchQuery);
    }, SEARCH_DELAY);

    setSearchQuery(currentSearchQuery);
    this.setState({
      searchDelayTimeout: timeout,
    });
  };

  clearQuery = () => {
    const { defaultShops, setShops, setSearchQuery } = this.props;

    setSearchQuery('');
    this.setState({ searchDelayTimeout: null });

    setShops(defaultShops);
    mapServices.reinitMapMarkers(defaultShops, true);
  };

  search = (searchQuery) => {
    const { shopsLoadRequest } = this.props;

    shopsLoadRequest(searchQuery);
  };

  selectOptions = () => {
    const { states } = this.props;
    return (
      Object.values(DEFAULT_SELECTORS).concat(states).map((state) => (
        { label: state, value: state }
      ))
    );
  };

  onChangeSelected = (event) => {
    const { setSelectedState } = this.props;

    setSelectedState(event.target.value);
  };

  onChangeFromPoint = (event) => {
    const { searchDelayTimeout } = this.state;
    const { setSearchQuery, selectedTravelMode } = this.props;
    const { mapService } = window;
    const currentSearchQuery = event.target.value;

    clearTimeout(searchDelayTimeout);

    const timeout = setTimeout(() => {
      if (currentSearchQuery === '' && window.directionsRenderer) {
        window.directionsRenderer.setMap(null);
        if (window.directionMarkers) {
          window.directionMarkers.forEach((marker) => marker.setMap(null));
        }
      }

      mapService.buildRoute(currentSearchQuery, selectedTravelMode);
    }, DIRECTIONS_DELAY);

    setSearchQuery(currentSearchQuery);
    window.fromDirection = currentSearchQuery;

    this.setState({
      searchDelayTimeout: timeout,
    });
  };

  render() {
    const {
      searchQuery, viewAllShops, selectedState, directionMode, directionTo,
    } = this.props;

    return (
      <div className={styles['search-wrapper']}>
        { !viewAllShops && !directionMode
          && (
          <Input
            value={searchQuery}
            id="search_input"
            className={styles.search}
            icon={<img src={searchIcon} alt="" width="14px" />}
            onChange={this.onChangeInput}
            placeholder="City & State"
          />
          )}
        { searchQuery !== '' && !viewAllShops && (
          <ClickableDiv className={styles.close} onClick={this.clearQuery}>
            <img src={CloseIcon} alt="clear search" width="16px" height="16px" />
          </ClickableDiv>
        )}
        { viewAllShops && !directionMode && (
          <Select
            className={styles.search}
            name="select stores from"
            value={selectedState}
            onChange={this.onChangeSelected}
            options={this.selectOptions()}
          />
        )}
        { directionMode && (
          <div className={styles.directions}>
            <div className={styles.from}>
              <span> A: </span>
              <Input
                value={searchQuery}
                className={styles.search}
                onChange={this.onChangeFromPoint}
                placeholder="Starting Directions"
              />
            </div>
            <div className={styles.to}>
              <span> B: </span>
              <div className={styles.info}>
                <div className={styles.name}>
                  { directionTo.name }
                </div>
                <div className={styles.address}>
                  { directionTo.full_address }
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

Search.propTypes = {
  shopsLoadRequest: PropTypes.func.isRequired,
  setShops: PropTypes.func.isRequired,
  defaultShops: PropTypes.arrayOf(PropTypes.shape({})),
  setSearchQuery: PropTypes.func.isRequired,
  searchQuery: PropTypes.string,
  viewAllShops: PropTypes.bool.isRequired,
  states: PropTypes.arrayOf(PropTypes.string),
  setSelectedState: PropTypes.func.isRequired,
  selectedState: PropTypes.string.isRequired,
  directionMode: PropTypes.bool.isRequired,
  directionTo: PropTypes.shape({
    name: PropTypes.string,
    full_address: PropTypes.string,
  }),
  selectedTravelMode: PropTypes.string.isRequired,
};

const mapStateToProps = (state) => ({
  defaultShops: defaultShopsSelector(state),
  searchQuery: searchQuerySelector(state),
  viewAllShops: viewAllShopsSelector(state),
  directionMode: directionModeSelector(state),
  states: statesSelector(state),
  selectedState: selectedStateSelector(state),
  directionTo: directionToSelector(state),
  selectedTravelMode: selectedTravelModeSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  shopsLoadRequest: (location) => {
    dispatch(shopsActions.shopsLoadRequest({ location }));
  },
  setShops: (entries) => {
    dispatch(shopsActions.setShops({ entries }));
  },
  setSearchQuery: (searchQuery) => {
    dispatch(shopsActions.setSearchQuery(searchQuery));
  },
  setSelectedState: (selectedState) => {
    dispatch(shopsActions.setSelectedState(selectedState));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Search);
